import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../style/ReuploadScan.css";
import { OrderType } from "../../Interfaces/Types/OrderType";
import { apiAxios } from "../../utils/apiAxios";
import { useNavigate } from "react-router-dom";
import JSZip from "jszip";
import { saveAs } from "file-saver";
interface Props {
  orders: OrderType[];
  onClose: () => void;
  onCancelClick: (caseIds: number[]) => void;
  onReuploadClick?: (caseID: number) => void;
  showSuccessToast?: boolean;
}
const API_PATH = process.env.REACT_APP_API_PATH_URL || "";
const ReuploadAddScanUnderreview: React.FC<Props> = ({ orders,
  onClose,
  onCancelClick,
  onReuploadClick,
  showSuccessToast }) => {
  const [orderDetails, setOrderDetails] = useState<any[]>([]);
  const [selectedCancelCaseIds, setSelectedCancelCaseIds] = useState<number[]>([]);
const [selectedReuploadCaseId, setSelectedReuploadCaseId] =
  useState<number | null>(null);
  const firstOrder = orders[0];

  const isClubbed = orders.length > 1;
  useEffect(() => {
  if (isClubbed) {
    setSelectedCancelCaseIds([]);
  }
}, [orders]);
  useEffect(() => {
    console.log("Orders received");
    console.log(orders);
    console.log("Case IDs:", orders.map(x => x.caseID));
  }, [orders]);

  const orderHeader =
    orderDetails.length > 0
      ? orderDetails[0]
      : firstOrder;

  const groupedCaseDetails = orderDetails.reduce((acc: any, item: any) => {
    if (!acc[item.caseID]) {
      acc[item.caseID] = [];
    }

    acc[item.caseID].push(item);
    return acc;
  }, {});

  const hasDownloadableFiles = orderDetails.some(
    (item) => item.imagePath && item.imagePath.trim() !== ""
  );
  const [loading, setLoading] = useState(false);
  const STATUS_CONFIG: Record<
    string,
    { className: string; bg: string }
  > = {
    "Need Attention": {
      className: "status-need-attention danger",
      bg: "red",
    },

    "Under Review": {
      className: "status-under-review",
      bg: "#ffcd39",
    },
    "Getting Prepared": {
      className: "status-getting-prepared",
      bg: "#F8F9FB",
    },

    "Completed": {
      className: "status-getting-prepared",
      bg: "#90EE90",
    },
    "Ready for Delivery": {
      className: "Readyfordelivery",
      bg: "#fff",
    },
    "Out for Delivery": {
      className: "outfordelivery",
      bg: "",
    },
    "Re-upload Scan": {
      className: "reupload-scan-btn",
      bg: "#000000",
    },
    
    "Delay Report (Design)": {
      className: "status-under-review",
      bg: "#b45309",
    },
    "Upload Scan": {
  className: "reupload-scan-btn",
  bg: "#000000",
},
  };

  const downloadFile = async (imagePath: string) => {
    try {
      const response = await fetch(`${API_PATH}/${imagePath}`);

      if (!response.ok) {
        toast.error("Unable to download file");
        return;
      }

      const blob = await response.blob();

      const fileName =
        imagePath.split("/").pop() || "Scan.stl";

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      toast.error("Download failed");
    }
  };

  const downloadAllFiles = async () => {
    try {
      const zip = new JSZip();

      const files = orderDetails.filter(
        (x) => x.imagePath
      );

      if (!files.length) {
        toast.error("No files found");
        return;
      }

      for (const file of files) {
        const response = await fetch(
          `${API_PATH}/${file.imagePath}`
        );

        if (!response.ok) continue;

        const blob = await response.blob();

        const fileName =
          file.imagePath.split("/").pop() ||
          `Tooth_${file.toothNumber}.stl`;

        zip.file(fileName, blob);
      }
const content = await zip.generateAsync({
  type: "blob",
});

const zipName = isClubbed
  ? `Clubbed_${firstOrder.clubGroupId}_Scans.zip`
  : `${orderHeader.orderID}_Scans.zip`;

saveAs(content, zipName);
    } catch (err) {
      console.error(err);
      toast.error("Zip download failed");
    }
  };

  useEffect(() => {
    if (orders.length > 0) {
      fetchReuploadScanDetail();
    }
  }, [orders, showSuccessToast]);

  useEffect(() => {
    console.warn(orderHeader, "orderHeaderreview")
  }, [orderHeader]);

  const fetchReuploadScanDetail = async () => {
    try {
      setLoading(true);

      const token = sessionStorage.getItem("token");
      const payload = {
        CaseIDs: orders.map(o => o.caseID),
      };

      const response = await apiAxios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Dentist/GetReuploadScanDetail`,
        payload,
        {
          headers: {
            AuthorizationData: token,
            "Content-Type": "application/json",
          },
        }
      );
    
      console.log("singleData:", response.data?.singleData);
      console.log("Rows:", response.data?.singleData?.length);

      if (response.data?.isSuccess) {
        console.log(response.data.singleData, "check");
        setOrderDetails(response.data.singleData);
      }
    } catch (error) {
      console.error("Reupload detail error:", error);
      toast.error("Failed to load scan details");
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();
  const formatETA = (eta: string | null) => {
    if (!eta) return "--";

    const date = new Date(eta);

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      month: "short",
      day: "numeric",
    });
  };
  useEffect(() => {
    debugger
    console.log("orderDetails state:", orderDetails);
  }, [orderDetails]);
console.log(
  "Clubbed Orders:",
  orders.map((order) => ({
    caseID: order.caseID,
    dentistTag: order.dentistTag,
    isDesignService: order.isDesignService,
    isDesignerReviewed: order.isDesignerReviewed,
  }))
);
const canCancelOrder = isClubbed
  ? orders.some(
    
      (order) =>
        

        !(order.isDesignService && order.isDesignerReviewed) &&
        order.dentistTag !== "Cancelled" &&
         order.dentistTag !== "Delivered" &&
         order?.dentistTag !== "Cancellation Under Review" &&
        order.dentistTag !== "Cancellation Under Reveiw" &&
        order.dentistTag !== "Completed" &&
        order.dentistTag !== "Ready for Delivery" &&
        order.dentistTag !== "Out for Delivery" &&
        order.currentOrderState !== "IN_MILLING"
    )
  :
    !(orderHeader.isDesignService && orderHeader.isDesignerReviewed) &&
    orderHeader?.dentistTag !== "Cancelled" &&
     orderHeader?.dentistTag !== "Delivered" &&
    orderHeader?.dentistTag !== "Cancellation Under Review" &&
    orderHeader?.dentistTag !== "Cancellation Under Reveiw" &&
    orderHeader?.dentistTag !== "Completed" &&
    orderHeader?.dentistTag !== "Ready for Delivery"  &&
    orderHeader.dentistTag !== "Out for Delivery" &&
    orderHeader?.currentOrderState !== "IN_MILLING"
    ;

  return (
    <>
      <div className="row  otp-margin-topsection">
        <div className="col-md-12 ">

          <div className="order-wrapper ">
            <div className="order-card">

              {/* ---------- FIXED HEADER (name + close button) ---------- */}
              <div className="order-card-fixed-header">
                {orderHeader && (
                  <div className="order-header">
                    &nbsp; {orderHeader.patientName}

                    <div className="header-actions">
                      <span
                        className="close-btn"
                        style={{ cursor: "pointer" }}
                        onClick={onClose}
                      >
                        ✕
                      </span>
                    </div>
                  </div>
                )}
              </div>

              {/* ---------- SCROLLABLE BODY (cases + eta + tables) ---------- */}
              <div className="order-card-scroll-body">

                {/* Show all clubbed orders */}
                {isClubbed && (
                  <div className="clubbed-orders-list">
                    <h6>Cases Included</h6>

                  {orders.map((order) => (

  <div
    key={order.caseID}
    className="clubbed-order-item"
  >
    


    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
     {![
  "Ready for Delivery",
  "Ready for Dispatch",
  "Out for Delivery",
  "Cancelled",
  "Cancellation Under Review",
  "Completed",
  "Completed(Design)"
].includes(order.dentistTag) && (
  <input
    type="radio"
    name="cancelCase"
    checked={selectedCancelCaseIds.includes(order.caseID)}
    onChange={() => setSelectedCancelCaseIds([order.caseID])}
  />
)}

      <strong>{order.orderID}</strong>
    </div>

    <span
      className={`status-pill-active ${STATUS_CONFIG[order.dentistTag]?.className || ""}`}
      title={order.dentistTag}
      style={{
        backgroundColor:
          STATUS_CONFIG[order.dentistTag]?.bg || "#ff0000",
        color:
          (STATUS_CONFIG[order.dentistTag]?.bg || "#ff0000") === "#ff0000"
            ? "#fff"
            : "inherit",
      }}
    >

      <i className="bi bi-clock-fill me-1"></i>
      {order.dentistTag}
    </span>

        {(
  ["Re-upload Scan", "Upload Scan"].includes(
    (order.dentistTag || "").trim()
  ) ||
  ["ATTENTION_REQUIRED", "WARRANTY_CLAIMED", "Upload_ScheduledFile"].includes(
    (order.currentOrderState || "").trim()
  )
) && (
  <button
    type="button"
    className="btn btn-danger btn-sm"
    style={{
      marginLeft: "10px",
      whiteSpace: "nowrap",
    }}
    onClick={(e) => {
      e.stopPropagation();
      onReuploadClick?.(order.caseID);
    }}
  >
    Upload Scan
  </button>
)}

  </div>

))}
                  </div>
                )}

                {orderHeader && (
                  <div className="eta order-header py-2">
                    <div className="ETA_main">
                      <span className="Expected">Expected ETA: </span>
                      <strong className="number-fontweight time-and-date-part">
                        {formatETA(orderHeader.expectedEta)}
                      </strong>
                    </div>


{/* Show status for single order */}
{!isClubbed && orderHeader?.dentistTag && (
  <span
    className={`status-pill-active ${
      STATUS_CONFIG[orderHeader.dentistTag]?.className || ""
    }`}
    style={{
      backgroundColor:
        STATUS_CONFIG[orderHeader.dentistTag]?.bg || "#ff0000",
      color:
        (STATUS_CONFIG[orderHeader.dentistTag]?.bg || "#ff0000") ===
        "#ff0000"
          ? "#fff"
          : "inherit",
    }}
  >
    <i className="bi bi-clock-fill me-1"></i>
    {orderHeader.dentistTag}
  </span>
)}

{/* Show Upload Scan button for single order */}
{!isClubbed &&
  (
    ["Re-upload Scan", "Upload Scan"].includes(
      (orderHeader?.dentistTag || "").trim()
    ) ||
    [
      "ATTENTION_REQUIRED",
      "WARRANTY_CLAIMED",
      "Upload_ScheduledFile",
    ].includes((orderHeader?.currentOrderState || "").trim())
  ) && (
    <button
      type="button"
      className="btn btn-danger btn-sm"
      style={{
        marginLeft: "10px",
        whiteSpace: "nowrap",
      }}
      onClick={() => onReuploadClick?.(orderHeader.caseID)}
    >
      Upload Scan
    </button>
  )}


                  </div>
                )}

                {orderHeader?.isDesignService && hasDownloadableFiles && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: "10px",
                    }}
                  >
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={downloadAllFiles}
                    >
                      Download All (ZIP)
                    </button>
                  </div>
                )}

                {Object.entries(groupedCaseDetails).map(([caseId, teeth]: any) => (
                  <div key={caseId} className="mb-4">

                    <div
                      style={{
                        background: "#f5f5f5",
                        padding: "10px",
                        borderRadius: "6px",
                        marginBottom: "10px",
                        fontWeight: 600
                      }}
                    >
                      Case : {teeth[0].orderID}
                    </div>
                    <div className="table-scroll-wrapper">
                      <table className="order-table order-table-dentist">
                        <thead>
                          <tr>
                            <th>Tooth</th>
                            <th>Material</th>
                            <th>Shade</th>

                            {orderHeader?.isDesignService && hasDownloadableFiles && (
                              <th>File</th>
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {teeth.map((item: any, index: number) => (
                            <tr key={index}>
                              <td>{item.toothNumber}</td>
                              <td>{item.materialName}</td>
                              <td>{item.shade}</td>

                              {orderHeader?.isDesignService && hasDownloadableFiles && (
                                <td>
                                  {item.imagePath ? (
                                    <button
                                      className="btn btn-outline-primary btn-sm"
                                      onClick={() => downloadFile(item.imagePath)}
                                    >
                                      Download
                                    </button>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}

                {orderHeader?.requestStatus === "REJECTED" &&
                  orderHeader?.rejectedReason && (
                    <div className="rejection-banner">
                      <div className="rejection-banner-title">
                        ⚠ Cancellation Request Rejected
                      </div>
                      <div className="rejection-banner-message">
                        {orderHeader.rejectedReason}
                      </div>
                    </div>
                  )}

              </div>
              {/* ---------- END SCROLLABLE BODY ---------- */}

              {/* ---------- FIXED FOOTER (buttons) ---------- */}
              <div className="order-footer">
                
{selectedReuploadCaseId !== null && (
  <button
    type="button"
    className="btn btn-contact-section"
    onClick={() => onReuploadClick?.(selectedReuploadCaseId)}
  >
    Re-upload Scan
  </button>
)}

                <button
                  className="btn btn-contact-section gray"
                  onClick={() =>
                    
                    navigate("/dentist/ContactSupport", {
                      state: {
                        caseIds: orders.map(o => o.caseID),
                        isClubbed,
                      },
                    })
                  }
                >
                  Contact Support
                </button>
               {canCancelOrder && (
                    <button
  type="button"
  className="btn btn-contact-section red"
  onClick={() => {
    if (isClubbed && selectedCancelCaseIds.length === 0) {
      toast.warning("Please select a case to cancel.");
      return;
    }

    onCancelClick(
      isClubbed
        ? selectedCancelCaseIds
        : [orderHeader.caseID]
    );
  }}
>
  Cancel Order
</button>
                  )}
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReuploadAddScanUnderreview;
